export default __webpack_public_path__ + "static/media/cross-icon.8ab42cb5.svg";